import { decodeHtmlEntities } from '~/lib/decodeHtmlEntities';

const EMOJIS = ['😡', '😠', '😐', '🙂', '😀'];

/** The emoji a gauge step shows learners when it has no label. */
export const stepEmoji = (index: number) => EMOJIS[index] ?? '';

/**
 * What learners see on a gauge step: its subvalue, else its value, else its
 * emoji. A label is stored as HTML text, so it is decoded once, to be shown
 * as plain text.
 */
export const stepLabelOf = (
  step: { subvalue?: string | null; value?: string | null } | undefined,
  index: number
) => {
  const label = step?.subvalue || step?.value;
  return label ? decodeHtmlEntities(label) : stepEmoji(index);
};

/** Whether each field a gauge step's label can show has text. */
export interface StepLabelFields {
  subvalue: boolean;
  value: boolean;
}

/**
 * The field a step's label is in: its subvalue, else its value. With neither,
 * the subvalue, which learners would see first.
 */
export const labelFieldOf = ({
  subvalue,
  value
}: StepLabelFields): keyof StepLabelFields =>
  !subvalue && value ? 'value' : 'subvalue';
